import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'fgb-facial-recognition-take-photo',
  templateUrl: './facial-recognition-take-photo.component.html',
  styleUrl: './facial-recognition-take-photo.component.scss',
})
export class FacialRecognitionTakePhotoComponent implements OnInit, OnDestroy {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() formData: FormControl = new FormControl();
  @Input() stepCounter: number = 1;
  @Output() nextStepChange = new EventEmitter();
  @Output() previousStepChange = new EventEmitter();
  private trigger: Subject<void> = new Subject<void>();
  public errors: WebcamInitError[] = [];

  ngOnInit(): void {}

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public cameraOptions: MediaTrackConstraints = {
    facingMode: { exact: 'user' }
  };

  handleImage(e: WebcamImage) {
    this.uploadedImage.setValue(e.imageAsDataUrl);
    let webcamImage = e;
    const arr = webcamImage.imageAsDataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], 'files', { type: mime });
    if (file) {
      this.formData.setValue(file);
    }
  }

  capturePhoto() {
    this.triggerSnapshot();
    this.nextStepChange.emit();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  ngOnDestroy(): void {
    this.trigger.complete();
  }
}
